var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"button noselect",attrs:{"tabindex":"0"},on:{"click":function($event){return _vm.clicked(_vm.hiddenKey)},"keyup":_vm.onEnterKey}},[_c('img',{attrs:{"src":require("@/assets/new.png")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }